import { inject,Injectable } from '@angular/core';

import { GTMService } from '@personal-area/global/gtm';
import { UniversalStorageService } from '@personal-area/storage';

import { GetFeedbackUserData } from '../models/usabilla.interface';

@Injectable({ providedIn: 'root' })
export class CollectUserDataService {
  private readonly _gtmService = inject(GTMService);
  private readonly _cookieService = inject(UniversalStorageService);

  private readonly _cookieClientId = 'client_id';
  private readonly _cookieNewAccount = 'open_first_account_in_last_2_days';

  public getUserData(): GetFeedbackUserData {
    const gtmData = this._gtmService.data;

    const userData: GetFeedbackUserData = {
      language: gtmData?.user?.language || '',
      user_id: Number(gtmData?.user?.id) || 0,
      user_pseudo_id: this._cookieService.getItem(this._cookieClientId) || '',
      country: gtmData?.user?.country || '',
    };

    const isNewRegistration =
      this._cookieService.getItem(this._cookieNewAccount) === 'true';
    if (isNewRegistration) {
      userData.after_registration = true;
    }

    const groupId = gtmData?.user?.getFeedback_group_id;
    if (groupId != null) {
      userData.group_id = String(groupId);
    }

    return userData;
  }
}
